if (!window.petomgDiscountInfoReady) {
  window.petomgDiscountInfoReady = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('.product-discount-info__close');
    if (close) {
      const details = close.closest('.product-discount-info');
      details.open = false;
      details.querySelector('summary')?.focus();
      return;
    }

    document.querySelectorAll('.product-discount-info[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('.product-discount-info[open]');
    if (!details) return;
    details.open = false;
    details.querySelector('summary')?.focus();
  });
}
